var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerhalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF4848",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24.75C20.8325 24.75 24.75 20.8325 24.75 16C24.75 11.1675 20.8325 7.25 16 7.25C11.1675 7.25 7.25 11.1675 7.25 16C7.25 20.8325 11.1675 24.75 16 24.75ZM15.75 11.1875C16.1642 11.1875 16.5 11.5233 16.5 11.9375V15.9375C16.5 16.3517 16.1642 16.6875 15.75 16.6875C15.3358 16.6875 15 16.3517 15 15.9375V11.9375C15 11.5233 15.3358 11.1875 15.75 11.1875ZM16.75 19.9375C16.75 20.4898 16.3023 20.9375 15.75 20.9375C15.1977 20.9375 14.75 20.4898 14.75 19.9375C14.75 19.3852 15.1977 18.9375 15.75 18.9375C16.3023 18.9375 16.75 19.3852 16.75 19.9375Z",
    fill: "#F45252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerhalo);
export default __webpack_public_path__ + "static/media/dangerhalo.f68ee646f74089c7385b1dbcbbf99cc4.svg";
export { ForwardRef as ReactComponent };